module.exports = __webpack_public_path__ + "static/img/bggzpg.74f9f65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bggzpg.png
// module id = 3YE1
// module chunks = 26